import dayjs from 'dayjs';
import DefaultError from '../components/defaultPage/defaultError';
import DefaultLoading from '../components/defaultPage/defaultLoading';
import DefaultNoData from '../components/defaultPage/defaultNoData';
import { DetailRecord, RecordList } from '../types';
export function rpx(t: number): number {
  return (t / 375) * window.innerWidth;
}
/**
 * 判断是否是手机号
 * @param tel 11位手机号
 * @returns
 */
export function validateTel(tel: string): boolean {
  return /^1[3456789]\d{9}$/.test(tel);
}

/// 验证身份证号
export function validateCardId(cardId: string) {
  if (cardId.length !== 18) {
    return false; // 位数不够
  }
  // 身份证号码正则
  let postalCode = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|[Xx])$/;
  // 通过验证，说明格式正确，但仍需计算准确性
  if (!postalCode.test(cardId)) {
    return false;
  }
  //将前17位加权因子保存在数组里
  const idCardList = ['7', '9', '10', '5', '8', '4', '2', '1', '6', '3', '7', '9', '10', '5', '8', '4', '2'];
  //这是除以11后，可能产生的11位余数、验证码，也保存成数组
  const idCardYArray = ['1', '0', '10', '9', '8', '7', '6', '5', '4', '3', '2'];
  // 前17位各自乖以加权因子后的总和
  let idCardWiSum = 0;

  for (let i = 0; i < 17; i++) {
    let subStrIndex = parseInt(cardId.substring(i, i + 1));
    let idCardWiIndex = parseInt(idCardList[i]);
    idCardWiSum += subStrIndex * idCardWiIndex;
  }
  // 计算出校验码所在数组的位置
  let idCardMod = idCardWiSum % 11;
  // 得到最后一位号码
  let idCardLast = cardId.substring(17, 18);
  //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
  if (idCardMod === 2) {
    if (idCardLast !== 'x' && idCardLast !== 'X') {
      return false;
    }
  } else {
    //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
    if (idCardLast !== idCardYArray[idCardMod]) {
      return false;
    }
  }
  return true;
}

/**
 * 判断是否是中文
 * @param str 字符串
 * @returns
 */
export function validateChina(str: string): boolean {
  let chinaReg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
  return chinaReg.test(str);
}

// 延迟执行
export function delay(ms: number): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}

// 解析价格
export function modelParsePrice(data: string | number) {
  var tmp = parseFloat((data ?? '0').toString()) ?? 0;
  return tmp;
}
// 解析流量
export function modelParseFlow(data: string | number) {
  var tmp = parseFloat((data ?? '0').toString()) ?? 0;
  return tmp / 1024 / 1024;
}
// 格式化价格
export function formatNumber(n: number | string | undefined | null) {
  let t = (n ?? 0).toString();
  if (t.includes('.') && parseInt(t) !== parseFloat(t)) {
    return parseFloat(t).toFixed(2);
  }
  return parseInt(t);
}

interface ListStatusParams {
  list?: RecordList<any>;
  tips?: string;
}
// 列表状态显示
export function dataListStatus({ list, tips }: ListStatusParams) {
  if (!list || list!.loaded !== true) {
    return <DefaultLoading key={Date.now().toLocaleString()} tips={'正在加载...'} />;
  } else if (list!.error) {
    return <DefaultError key={Date.now().toLocaleString()} tips={list!.error} />;
  } else if ((list!.results?.length || 0) <= 0) {
    return <DefaultNoData key={Date.now().toLocaleString()} tips={tips} />;
  }
  return null;
}

interface DetailStatusParams {
  detail: DetailRecord<any>;
  tips?: string;
}
// 详情状态显示
export function dataDetailStatus({ detail, tips }: DetailStatusParams) {
  if (!detail || detail!.loaded !== true) {
    return <DefaultLoading key={Date.now().toLocaleString()} tips={'正在加载...'} />;
  } else if (detail!.error) {
    return <DefaultError key={Date.now().toLocaleString()} tips={detail!.error} />;
  } else if (!detail?.result) {
    return <DefaultNoData key={Date.now().toLocaleString()} tips={tips} />;
  }
  return null;
}
// 解析url参数
export function parseLocationParams(params?: string): { [x: string]: string } {
  if (!params) return {};
  let real = params.startsWith('?') ? params.split('?')[1] : params;
  let _tmpList = real.split('&') || [];
  let p: { [x: string]: string } = {};
  for (let _tmp of _tmpList) {
    let [_k, _v] = _tmp.split('=');
    p[_k] = _v;
  }
  return p;
}
// 深拷贝
export function cloneDeep(obj: any) {
  if (typeof obj !== 'object') return obj;
  return JSON.parse(JSON.stringify(obj));
}
/**
 * 清除对象内的空Key
 * @param _p 数据
 * @returns 数据
 */
export function clearEmptyKey(params: any) {
  let _p = cloneDeep(params);
  Object.keys(_p).forEach((i) => {
    if (!_p[i]) {
      delete _p[i];
    } else if (typeof _p[i] === 'object') {
      if (_p[i] instanceof Object) {
        _p[i] = clearEmptyKey(_p[i]);
      }
      if (!Object.keys(_p[i]).length) {
        delete _p[i];
      }
    }
  });
  return _p;
}

// 格式化时间
export function formatDateDiff(
  minDay: dayjs.Dayjs,
  maxDay: dayjs.Dayjs,
  hideSecond: boolean = false,
  hideMinute: boolean = false
) {
  if (minDay.isAfter(maxDay)) return null;
  var second = maxDay.diff(minDay, 'second');
  var day = Math.floor(second / 3600 / 24);

  var hour = Math.floor((second - day * 3600 * 24) / 3600);
  var min = Math.floor((second - hour * 3600 - day * 3600 * 24) / 60);
  var sec = second % 60;
  var timeStr = '';
  if (day > 0) {
    timeStr += day + '天';
  }
  if (hour > 0) {
    timeStr += (hour < 10 ? `0${hour}` : hour.toString()) + '时';
  }
  if (hideMinute) return timeStr;
  timeStr += (min < 10 ? `0${min}` : min.toString()) + '分';
  if (hideSecond) return timeStr;
  timeStr += (sec < 10 ? `0${sec}` : sec.toString()) + '秒';
  return timeStr;
}
